const declination = {
  night: (num: number): string => (num >= 5 || num === 0 ? 'dób' : num >= 2 ? 'doby' : 'doba'),
}

export default declination
